const failureKey = 'cloudphone:h5:dev-auth-failure:v1'
const maximumAgeMs = 5 * 60 * 1000

export function rememberAuthFailure(error) {
  if (process.env.NODE_ENV !== 'development') return

  try {
    const headers = error.config?.headers
    const authorization = typeof headers?.get === 'function'
      ? headers.get('Authorization')
      : headers?.Authorization || headers?.authorization
    const code = error.response?.data?.code
    // Preserve only diagnostic metadata across the redirect, never credentials or bodies.
    sessionStorage.setItem(failureKey, JSON.stringify({
      at: Date.now(),
      path: new URL(error.config?.url || '/', window.location.origin).pathname,
      status: error.response?.status,
      code: typeof code === 'number' && Number.isFinite(code) ? code : null,
      authenticated: Boolean(authorization),
      frame: window.parent !== window
    }))
  } catch {
    // Diagnostics must not change authentication when browser storage is unavailable.
  }
}

export function clearAuthFailure() {
  if (process.env.NODE_ENV !== 'development') return
  try {
    sessionStorage.removeItem(failureKey)
  } catch {
    // Storage may be restricted in embedded browsers.
  }
}

export function readAuthFailureMessage() {
  if (process.env.NODE_ENV !== 'development') return ''

  try {
    const failure = JSON.parse(sessionStorage.getItem(failureKey))
    if (!failure || !Number.isFinite(failure.at) || Date.now() - failure.at > maximumAgeMs) return ''
    if (failure.status !== 401 || typeof failure.path !== 'string') return ''
    const code = typeof failure.code === 'number' ? `\uff0c\u4e1a\u52a1\u7801 ${failure.code}` : ''
    const authentication = failure.authenticated ? '\u5df2\u643a\u5e26\u8ba4\u8bc1\u4fe1\u606f' : '\u672a\u643a\u5e26\u8ba4\u8bc1\u4fe1\u606f'
    const source = failure.frame ? '\u9884\u89c8\u5b50\u9875\u9762' : '\u4e3b\u9875\u9762'
    return `\u767b\u5f55\u8bca\u65ad\uff1a${source}\u8bf7\u6c42 ${failure.path} \u8fd4\u56de HTTP 401${code}\uff1b${authentication}\uff0c\u9875\u9762\u56e0\u6b64\u6e05\u9664\u767b\u5f55\u72b6\u6001\u3002`
  } catch {
    return ''
  }
}
